import * as Yup from "yup";

//TODO: DEPRECATED ridecapital/backlog#1912
export const TypeOfInvestedCapitalSchema = (t) =>
  Yup.object().shape({
    "type-of-invested-capital": Yup.string().required(t("generic:validation-required"))
  });
